/**
* Testimonial JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonial-slider-content' ).length ) {
        $( '.testimonial-slider-content' ).each( function( index, element ) {
          const contentSlider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perMove: 1,
            perPage: 1,
            pagination: false,
            speed: 800,
          } );

          contentSlider.mount( {} );

          if ( $( '.testimonial-slider-service-cards' ).length ) {
            const serviceCardsSlider = new Splide( $( '.testimonial-slider-service-cards' )[0], {
              type: 'fade',
              perMove: 1,
              perPage: 1,
              arrows: false,
              pagination: false,
              speed: 800,
            } );

            serviceCardsSlider.mount( {} );
            contentSlider.sync( serviceCardsSlider );
          }

          $( '.highlighted-text' ).each( function( index, element ) {
            $( element ).css( 'background-color', 'transparent' );
            $( element ).prepend( '<div class="js-reveal absolute inset-0 -z-1 bg-brand-off-white"></div>' );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial', COMPONENT );
} )( app );
